import { AppBar, Toolbar } from '@atom/mui';
import colors from '@atom/styles/colors';
import layoutStyles from '@atom/styles/layout';

import SearchBar from './search/SearchBar';
import Logo from './Logo';
import NavControls from './NavControls';

const styles = {
  toolBarStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: '1rem',
  },
  navBarStyle: {
    height: layoutStyles.topNavHeight,
    backgroundColor: colors.neutral.white,
    boxShadow: '0 2px 4px 1px',
    color: colors.utility.boxShadow,
    position: 'fixed',
    top: 0,
  },
};

/*
 * The UnknownError route renders this component also. A child that throws
 * after a network or type error crashes the error page, which remounts the
 * bar and requests again, recursively. Wrap any child that fetches in its
 * own ErrorBoundary (see AiChat in NavControls).
 */
const TopNavigationBar = () => (
  <AppBar style={styles.navBarStyle}>
    <Toolbar style={styles.toolBarStyle}>
      <Logo />
      <SearchBar />
      <NavControls />
    </Toolbar>
  </AppBar>
);

export default TopNavigationBar;
